import { isDocumentCategorySelected } from "../constants/documentManagementConstants";
import type { DatasetOptionUi } from "../types/documentManagementUiTypes";

export type UploadDatasetTargetMode = "existing" | "new";

export function isUploadFilesStepValid(filesCount: number): boolean {
  return filesCount > 0;
}

export function isUploadRolesValid(uploadRoleAccess: string[]): boolean {
  if (!uploadRoleAccess.length) return false;
  if (uploadRoleAccess.includes("*")) return true;
  return uploadRoleAccess.some((role) => Boolean(role?.trim()));
}

export function isUploadDestinationStepValid(
  datasetTargetMode: UploadDatasetTargetMode,
  datasetSelection: number | "",
  apiDatasets: DatasetOptionUi[],
  newDatasetName: string,
  uploadRoleAccess: string[]
): boolean {
  const datasetOk =
    datasetTargetMode === "new"
      ? Boolean(newDatasetName.trim())
      : apiDatasets.length > 0 && datasetSelection !== "";
  return datasetOk && isUploadRolesValid(uploadRoleAccess);
}

export function isUploadCategoryStepValid(uploadCategory: string): boolean {
  return isDocumentCategorySelected(uploadCategory);
}

export function isUploadSubmitReady(
  filesCount: number,
  uploadCategory: string,
  datasetTargetMode: UploadDatasetTargetMode,
  datasetSelection: number | "",
  apiDatasets: DatasetOptionUi[],
  newDatasetName: string,
  uploadRoleAccess: string[],
  busy: boolean
): boolean {
  return (
    !busy &&
    isUploadFilesStepValid(filesCount) &&
    isUploadDestinationStepValid(
      datasetTargetMode,
      datasetSelection,
      apiDatasets,
      newDatasetName,
      uploadRoleAccess
    ) &&
    isUploadCategoryStepValid(uploadCategory)
  );
}
